import { render } from "./AdminRoleEdit.vue?vue&type=template&id=95c6aea6&ts=true"
import script from "./AdminRoleEdit.vue?vue&type=script&lang=ts"
export * from "./AdminRoleEdit.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/adminold.quickup.uk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__